'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }return target;
};

require('es5-shim');
require('es5-shim/es5-sham');
var React = require('react');
var ReactDOM = require('react-dom');

var CoreSelector = function (_React$Component) {
    _inherits(CoreSelector, _React$Component);

    function CoreSelector(props) {
        _classCallCheck(this, CoreSelector);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(CoreSelector).call(this, props));

        var selectedItem = null;
        props.children.map(function (item, i) {
            if (item.props.label == _this.props.selected) selectedItem = item;
        });
        _this.state = {
            numberSelectedItems: 0,
            selected: _this.props.selected || '',
            selectedItem: selectedItem
        };
        return _this;
    }

    _createClass(CoreSelector, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this3 = this;

            var self = this;
            if (nextProps.selected != this.props.selected) {
                this.setState({ selected: nextProps.selected });
                self.props.children.map(function (item, i) {
                    if (item.props.label == _this3.state.selected) self.setState({ selectedItem: item });
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var options = React.Children.map(this.props.children, function (option) {
                var _option$props = option.props;
                var label = _option$props.label;

                return React.createElement(
                    'div',
                    { className: _this2.state.selected == label ? "active" : "noactive",
                        onClick: _this2.selectedChanged.bind(_this2, label) },
                    option
                );
            });

            return React.createElement('div', {
                className: this.props.className || '' }, options);
        }
    }, {
        key: 'selectedChanged',
        value: function selectedChanged(newSelection) {}
    }, {
        key: 'updateSelected',
        value: function updateSelected(newSelection) {
            if (this.state.numberSelectedItems === 0) {
                this.setState({ selected: newSelection });
            } else if (process.env.NODE_ENV !== 'production') {
                var message = "Cannot select a different radio button while another radio button " + "has the 'checked' property set to true.";
                console.error(message);
            }
        }
    }, {
        key: 'getSelectedItem',
        value: function getSelectedItem() {
            return this.state.selectedItem;
        }
    }]);

    return CoreSelector;
}(React.Component);

module.exports = CoreSelector;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/libcomponents/core-selector.js
 ** module id = 91
 ** module chunks = 0
 **/